@if (invite && action) {
  <div class="" style="text-align: center;">
    <h4>{{ action }} Invitation from {{ invite.inviter }}</h4><br/>
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}

@if (error) {
  <div class="d-flex justify-content-around">
    <div class="alert alert-danger" role="alert">
      <strong> {{ error.status }}</strong><br/>
      {{ error.error }}
    </div>
  </div>
}

@if (!error && !invite) {
  <div class="d-flex justify-content-around">
    <strong>Loading...</strong>
    <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
  </div>
}

